import { useContext } from 'react';
import { ParcoursFormaliteContext } from './ParcoursFormaliteContext';

export function useParcoursFormalite() {
    const ctx = useContext(ParcoursFormaliteContext);
    return ctx;
}
